(function ($, Drupal, settings) {

  'use strict';

  Drupal.behaviors.SAMLUserLogin = {
    attach: function (context, settings) {

      // Use JavaScript to force ?destination={{ path }} onto all /saml/login links, only if it is not already there
      $(once('SAMLUserLogin', "a[href^='/saml/login'], a[href^='/user/login']", context)).each(function() {
        let href = $(this).attr('href');

        if (href.indexOf("?destination=") < 0) {
          if (window.location.pathname != '/') {
            href += '?destination=' + window.location.pathname;
            $(this).attr('href', href);
          }
        }
      });
    }
  }

})(jQuery, Drupal, drupalSettings);
